//  Copyright (c) 2018 First Foundry Inc. All rights reserved.

export const PATH = 'venues'
export const SET_LIST = `${PATH}/SET_LIST`
export const SELECT = `${PATH}/SELECT`
